import React, { useEffect, useState } from 'react';
import { Card, Checkbox, Form, Select, SelectProps } from 'antd';
import './style/style.css';
import { parseISO, format } from 'date-fns';
import { useFileStore } from '../../../store/devices/fileStore';
import { File } from '../../../types/File';
import { useAuthStore } from '../../../store/auth/auth';
import { useOnlineStateStream } from '../../../store/devices/onlineStream';
import { VIDEO_FILE_PREVIEW } from '../../../api/file/FilePreview';
import img from './Video picture.png';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import ButtonAction from '../../buttons/buttonAct/ButtonAction';
import { useFileSelectionStore } from '../../../store/devices/useSelectedRowKeysFilesRS';
import { useOpenMoreDetails } from '../../../store/devices/useShowMoreDetails';
import { useSelectedFile } from '../../../store/devices/getSelectedFile';
import { formatDuration } from '../../../utils/shared/helpers/formatDuration';
import imgVideo from '../../layouts/camera/Video.png';
import imgMicrophone from '../../../utils/app/assets/images/Radio set.png';
import { useFilesStore } from '../../../store/devices/FilesDevicesFromDB';
import { message, Upload } from 'antd';
import { updateFileRating } from '../../../api/file/updateFile';

interface CardComponentProps {
    file: File;
    isSelected: boolean;
    onCheckboxChange: (fileId: string, checked: boolean) => void;
    onFileUpdated?: () => void;
}

const CardComponentFile: React.FC<CardComponentProps> = ({ file, onFileUpdated }) => {
    const { setSelectedFileUID } = useFileStore();
    const { user, SmartDVRToken } = useAuthStore.getState();
    const { setIsStreamOnline } = useOnlineStateStream();
    const [previewUrlVideo, setPreviewUrlVideo] = useState<string>('');
    const [previewUrlJpg, setPreviewUrlJpg] = useState<string>('');
    const [size] = useState<SizeType>('middle');
    const { selectedFiles, setSelectedFiles } = useFileSelectionStore();
    const { setOpenMoreDetails } = useOpenMoreDetails();
    const { setSelectedFile } = useSelectedFile();
    const { updateSingleFileInStore } = useFilesStore();
    const [loading, setLoading] = useState(false);

    const handleDeviceClick = (FileUid: string) => {
        setSelectedFileUID(FileUid);
        setIsStreamOnline(false);

        if (!file) {
            setOpenMoreDetails(false);
        }
        setSelectedFile(file);
        setOpenMoreDetails(true);
    };

    useEffect(() => {
        const fetchPreview = async () => {
            if (user?.login) {
                try {
                    const preview = await VIDEO_FILE_PREVIEW(file.UID, SmartDVRToken, user.login);
                    if (file.fileType === 'jpg') {
                        setPreviewUrlJpg(preview);
                    }
                    setPreviewUrlVideo(preview);
                } catch (error) {
                    console.error('Error fetching file preview:', error);
                }
            }
        };

        fetchPreview();
    }, [file, SmartDVRToken, user]);

    const handleCheckboxChange = (fileId: string, checked: boolean) => {
        setSelectedFiles(fileId, checked);
    };

    // Function to format the date
    const formatDate = (isoDate: string): string => {
        const parsedDate = parseISO(isoDate);
        // Добавляем смещение -5 часов
        const adjustedDate = new Date(parsedDate.getTime() - 5 * 60 * 60 * 1000);
        return format(adjustedDate, 'dd.MM.yy - HH:mm:ss');
    };

    const displayDate = formatDate(file.start);

    const options: SelectProps['options'] = [
        { label: '1 - наименьшая секретность', value: '0' },
        { label: '2 - низкая секретность', value: '1' },
        { label: '3 - средний уровень секретности', value: '2' },
        { label: '4 - повышенная секретность', value: '3' },
        { label: '5 - высокая секретность', value: '4' },
    ];

    const handleChangeUrgent = async (value: string) => {
        if (!user || !SmartDVRToken) {
            message.error('Ошибка авторизации');
            return;
        }

        setLoading(true);
        try {
            const ratingValue = Number(value);

            // Обновляем на сервере
            await updateFileRating(file.UID, ratingValue, user.login, SmartDVRToken);

            // Обновляем в хранилище
            const updatedFile = { ...file, rating: ratingValue };
            updateSingleFileInStore(updatedFile);

            message.success('Секретность обновлена');
            if (onFileUpdated) {
                onFileUpdated();
            }
        } catch (error) {
            console.error('Ошибка при обновлении секретности:', error);
            message.error('Не удалось обновить секретность');
        } finally {
            setLoading(false);
        }
    };

    const showDrawerMoreDetails = () => {
        if (!file) {
            setOpenMoreDetails(false);
        }
        setSelectedFile(file);
        setOpenMoreDetails(true);
    };

    const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = imgVideo;
    };

    const handleErrorAudio = (e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = imgMicrophone;
    };

    return (
        <div className="containerCardFile">
            <Checkbox
                className="fileCheckbox"
                checked={!!selectedFiles[file.UID]}
                onChange={(e) => handleCheckboxChange(file.UID, e.target.checked)}
                onClick={(e) => e.stopPropagation()}
                key={file.UID}
            />
            <div className="coverFile" onClick={() => handleDeviceClick(file.UID)}>
                <Card
                    className="coverCardFile"
                    key={file.UID}
                    cover={
                        file.fileType === 'jpg' ? (
                            <img
                                className="imgPreview"
                                src={previewUrlJpg}
                                alt={'Ошибка загрузки превью'}
                                onError={handleError}
                            />
                        ) : file.fileType === 'mp4' || file.fileType === 'mpd' ? (
                            <img
                                className="imgPreview"
                                alt={'Ошибка загрузки превью'}
                                src={previewUrlVideo}
                                onError={handleError}
                            />
                        ) : (
                            <img
                                className="imgPreview"
                                src={img}
                                alt={'Ошибка загрузки превью'}
                                onError={handleErrorAudio}
                            />
                        )
                    }
                />
            </div>
            <div className="propertiesFile">
                <h1 className="nameFile">
                    {displayDate}
                    {file.fileType !== 'jpg' && (
                        <span
                            className={'body medium'}
                            style={{ color: 'var(--gray-01)', marginLeft: 8 }}
                        >
                            ({formatDuration(file.duration)})
                        </span>
                    )}
                </h1>
                <div className="propertyGroupFile">
                    <h3 className="propertyFile">{file.size.toFixed(1)} мБ</h3>
                    <div className="urgentSet">
                        <Form
                            className="form"
                            name="basic"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValues={{
                                rating: file.rating?.toString(), // преобразуем число в строку для Select
                                caseNumber: file.caseNumber,
                                caseDescription: file.caseDescription,
                            }}
                            style={{ maxWidth: '100%' }}
                            // onFinish={onFinish}
                        >
                            <Form.Item
                                // label={<span className="inputLabel">Секретность</span>}
                                name="rating"
                                rules={[{ required: false }]}
                            >
                                <Select
                                    className="selectUrgent"
                                    size={size}
                                    // defaultValue={file.rating}
                                    value={file.rating?.toString()}
                                    onChange={handleChangeUrgent}
                                    style={{ width: 152, marginBottom: 16 }}
                                    options={options}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardComponentFile;
